export default __webpack_public_path__ + "static/media/rika_m.c805b5f6.jpg";